// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type InfoCircle20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle20Filled: FC<InfoCircle20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.344 13.5h1.312V9.125H9.344V13.5Zm.652-5.688a.644.644 0 0 0 .469-.187.625.625 0 0 0 .191-.465.644.644 0 0 0-.187-.469.625.625 0 0 0-.465-.191.644.644 0 0 0-.469.188.625.625 0 0 0-.191.464c0 .185.062.341.187.47.125.127.28.19.465.19ZM10.005 17c-.963 0-1.87-.182-2.721-.547A7.056 7.056 0 0 1 5.05 14.95a7.057 7.057 0 0 1-1.504-2.232A6.841 6.841 0 0 1 3 9.992c0-.967.182-1.873.547-2.717a7.058 7.058 0 0 1 3.736-3.728A6.841 6.841 0 0 1 10.008 3c.967 0 1.873.182 2.717.547a7.084 7.084 0 0 1 3.728 3.732c.365.847.547 1.753.547 2.716 0 .963-.182 1.87-.547 2.721a7.056 7.056 0 0 1-3.732 3.737 6.799 6.799 0 0 1-2.716.547Z" />
        </svg>
    );
};

export default InfoCircle20Filled;
